import React, { useState } from 'react';
import CustomInput from '../../FormComponents/CustomInput/CustomInput';
import IfscDetails from '../IfscDetails/IfscDetails';
import { SelectInput } from 'unified-ui-components-library';
import { getApiData } from '../../../api/api';
import { ACCOUNT_TYPE_OPTIONS } from '../../../utils/constants';
import AxiosRequest from '../../../utils/axios';
import DotsLoader from '../../Loader/DotsLoader/DotsLoader';

const axios = new AxiosRequest().getClient();

const BankDetailsForm = ({
  accountNumber,
  setAccountNumber,
  fullName,
  setFullName,
  ifscCode,
  setIfscCode,
  accountType,
  setAccountType,
  dateValue,
  setDateValue,
  ifscError,
  setIfscError,
  fetchedDetails,
  setFetchedDetails,
  userType
}) => {

  const [loading, setLoading] = useState(false);

  const fetchBankDetails = async () => {
    if (ifscCode.length === 11) {
      try {
        setLoading(true)
        const { url, body } = getApiData("ifscmicr");
        body.request.payload.ifsc = ifscCode;
        body.request.payload.transactionId = localStorage.getItem("posvRefNumber");
        body.request.payload.channel = localStorage.getItem("channelName");

        const response = await axios.post(url, body);
        const payload = response?.data?.response?.payload;
        const msgCode = response.data?.response?.msgInfo?.msgCode;

        if (msgCode === '200') {
          setFetchedDetails({
            micr: payload.microCode,
            bankName: payload.micrBankName,
            branchName: payload.micrBranchName,
          });
          setIfscError("");

        } else {
          setIfscError("Please enter a valid IFSC code");
          setFetchedDetails(null);
        }
      } catch (error) {
        console.error(error);
        setIfscError("Something went wrong!");
        setFetchedDetails(null);
      } finally {
        setLoading(false)
      }
    }
  };


  if(loading) {
    return <DotsLoader msg={"Loading details..."} />
  }

  return (
    <div className="bankDetailsInputs">
      <CustomInput
        label="Bank Account Number"
        maxLength={18}
        name="accountNumber"
        onChange={(e) => {
          if(e.target.value >= 0 && e.target.value?.length <= 18) {
            setAccountNumber(e.target.value)
          }
        }}
        placeholder=" "
        type="number"
        value={accountNumber}
      />

      <CustomInput
        label="Name of Account Holder"
        maxLength={100}
        name="fullName"
        onChange={(e) => setFullName(e.target.value.toUpperCase())}
        placeholder=" "
        type="text"
        value={fullName}
        disabled={userType === "proposer"}
      />

      <CustomInput
        label="IFSC Code"
        maxLength={11}
        name="ifscCode"
        onChange={(e) => {
          const value = e.target.value.toUpperCase();
          setIfscCode(value);
          setIfscError("");
          setFetchedDetails(null);
        }}
        onBlur={() => { fetchBankDetails(); }}
        placeholder=" "
        type="text"
        value={ifscCode}
      />
      {ifscError && <p className="errorMsg">{ifscError}</p>}

      {fetchedDetails && (
        <IfscDetails micr={fetchedDetails.micr} bankName={fetchedDetails.bankName} branchName={fetchedDetails.branchName} />
      )}

      <div className="glide-custom-select">
        <SelectInput
          autoComplete="off"
          label="Type of Account"
          onChange={(val) => setAccountType(val)}
          options={ACCOUNT_TYPE_OPTIONS.map(label => ({ label }))}
          value={accountType}
        />
      </div>

      <div className="form-container">
        <div className={`floating-label ${dateValue ? "has-value" : ""}`}>
          <input
            type="date"
            value={dateValue}
            onChange={(e) => setDateValue(e.target.value)}
            dateFormat="dd-MM-yyyy"
            placeholderText=""
            className="date-input"
            required
            max={new Date().toISOString().split("T")[0]}
            style={{ pointerEvents: "auto" }}
          />
          <label style={{ pointerEvents: "none" }}>Bank Account Opening Date</label>
        </div>
      </div>
    </div>
  );
}

export default BankDetailsForm;